import styled from "@emotion/styled";
import {Styles} from "@tpd-web-common-libs/nodejs-library";


export const SearchBar = styled.div`
    width: 100%;
    height: 100%;
    ${Styles.BreakpointsUtils.mobileOnly(`
      top: -3px;
      position: relative;
  `)}

    ${Styles.BreakpointsUtils.tabletOnly(`
      width: 420px;
  `)}
`;

export const MySearchNavbar = styled.div`
    margin-top: 7px;
    border: 1px solid ${Styles.Themes.UnipolColors.blueOne};

    ${Styles.BreakpointsUtils.mobileOnly(`
      border: none;
      height: 44px;
      width: 100%;
      margin-top: 3px;
  `)}
    ${Styles.BreakpointsUtils.tabletOnly(`
      width: 420px;
      height: 44px;
      margin-top: 0;
  `)}
    
    input {
        box-shadow: none !important;
        font-size: 14px !important;
        border: none !important;
        color: ${Styles.Themes.UnipolColors.blueOne} !important;
        padding: 10px 12px !important;
        ${Styles.BreakpointsUtils.mobileOnly(`
            height: 41px !important;
            padding: 10px 13px;
        `)}
        ${Styles.BreakpointsUtils.tabletOnly(`
            height: 100% !important;
       `)}
        ${Styles.BreakpointsUtils.desktopOnly(`
            height: 38px !important;
        `)}
        
        &.form-control::placeholder {
            color: ${Styles.Themes.UnipolColors.blueOne};
            font-family: ${Styles.GlobalStyleVariables.widgetVariablesStyle.$medium}
            font-size: 14px;

            ${Styles.BreakpointsUtils.mobileOnly(`
            box-shadow: none;
            font-size: 16px;
        `)}
            ${Styles.BreakpointsUtils.tabletOnly(`
            font-family: "Unipol";
            font-size: 16px;
        `)}
        }
    }
    
    .input-group-addon {
        background: transparent;
        border: none;
        color: ${Styles.Themes.UnipolColors.blueOne};
        padding: 0;
        border-radius: 0;

        &.active {
            background-color: #c4151c;

            .tpd_search_icon {
                color: ${Styles.Themes.UnipolColors.white};
            }
        }

        .tpd_search_icon {
            ${Styles.BreakpointsUtils.mobileOnly(`
                font-size: 40px;
            `)}
            font-size: 35px;
        }
    }
`;


export const ResSearchContainer = styled.div`
    
    .bk_154 {
        //display: none;
        display: block;
        border: 1px solid ${Styles.Themes.UnipolColors.blueSeven};
        border-top: none;
        background-color: #fff;
        position: relative;
        z-index: 234;
        color: #193a56;
        top: 0px;
        margin-right: 46.5px;
        
        &.tpd_bk154_desktop {
            margin-right: 0;
        }

        .tpd_separatorTop {
            margin: 0 5px;
            background-color: ${Styles.Themes.UnipolColors.blueSeven};
            height: 2px;
        }

        .tpd_separator {
            margin: 0 5px;
            background-color: #c1c1c1;
            height: 1px;
        }

        .tpd_resSearchBox {
            padding: 21px 26px;
            display: table;
            width: 100%;

            &:hover {
                background-color: ${Styles.Themes.UnipolColors.blueTen};
                cursor: pointer;
            }

            .tpd_label {
                display: table-cell;
                text-align: left;
                font-family: Unipol;
                color: #193a56;
                font-size: 18px;
                text-transform: capitalize;
                word-break: break-all;

                ${Styles.BreakpointsUtils.desktopOnly(`
                    -webkit-transition: all 0.25s ease-out 0s;
                    -moz-transition: all 0.25s ease-out 0s;
                    -ms-transition: all 0.25s ease-out 0s;
                    -o-transition: all 0.25s ease-out 0s;
                    transition: all 0.25s ease-out 0s;
                `)}
            }
        }

        .tpd_resSearchViewAll {
            padding: 20px 30px;
            color: ${Styles.Themes.UnipolColors.blueOne};
            text-decoration: underline;
            font-size: 16px;
            font-family: Unipol;
            color: ${Styles.Themes.UnipolColors.blueThirteen};
            font-size: 18px;
            text-align: left;
            
            &:active,
            &:hover {
                color: ${Styles.Themes.UnipolColors.white};
                opacity: 0.8;
            }
            
            ${Styles.BreakpointsUtils.tabletAndDesktopOnly(`
                -webkit-transition: all 0.25s ease-out 0s;
                -moz-transition: all 0.25s ease-out 0s;
                -ms-transition: all 0.25s ease-out 0s;
                -o-transition: all 0.25s ease-out 0s;
                transition: all 0.25s ease-out 0s;
            `)}
        }
    }
`;
